const env = {
    production: false,
    api: {
        host: 'https://api-retcercano-dev.ripley.com.pe/auth',
        // host: 'http://localhost:3001/auth',
        x_api_key: 'ZETfsMLquY9VUzKwewJsQv4I413wIwdEzFlR9B20',
    },
    recaptcha: {
        webKey: "6Lcw1jUbAAAAABdUuLRdMRPjDudQkEyO1I7E9rV-"
    }
  }
  
  export default env;